import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import { masterDataReducer } from "./Components/EmployeeInformation/Slice";
import employeeReducer from "./Components/EmployeeInformation/employeeSlice";

// STEP 1: Combine all slice reducers
const appReducer = combineReducers({
  masterData: masterDataReducer,
  employee: employeeReducer,
});

// STEP 2: Handle logout reset in root reducer
const rootReducer = (state, action) => {
  if (action.type === "auth/logoutUser/fulfilled") {
    localStorage.clear();
    state = undefined;
  }
  return appReducer(state, action);
};

// STEP 3: Set up redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "locations"], // only persist auth slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// STEP 4: Configure store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
